document.addEventListener("DOMContentLoaded", function() {
  const carousel = document.querySelector(".custom-carousel");
  const slides = document.querySelectorAll(".carousel-slide");
  let index = 0;
  const totalSlides = slides.length;

  setInterval(() => {
    index++;
    if (index > totalSlides - 1) index = 0;
    carousel.style.transform = `translateX(-${index * 33.333}%)`;
  }, 3000); // 3 seconds per slide
});
